import React from 'react';
import Relay from 'react-relay';

class SportunityDashboard extends React.Component {

    constructor(props) {
        super(props);
    }

    calculateKindStats(sportunities) {
        let kinds = [];

        sportunities.forEach(sportunity => {
            let kind = sportunity.node.kind ;
            kinds.push(kind);
        });

        let counts = {};

        for(var i = 0; i< kinds.length; i++) {
            var num = kinds[i];
            counts[num] = counts[num] ? counts[num]+1 : 1;
        }

        let tab = [];

        for (var count in counts) {
            let percentage = Math.round(counts[count] * 100 / kinds.length);
            tab.push([count, counts[count],percentage]);
        }

        return tab;
    }

    calculatePriceStats(sportunities) {
        let prices = [];

        sportunities.forEach(sportunity => {
            let price = 0 ;
            if (sportunity.node.price) price = sportunity.node.price.cents;
            if (price == 0) price = "FREE";
            else price = "PAYING";
            prices.push(price);
        });

        let counts = {};

        for(var i = 0; i< prices.length; i++) {
            var num = prices[i];
            counts[num] = counts[num] ? counts[num]+1 : 1;
        }

        let tab = [];

        for (var count in counts) {
            let percentage = Math.round(counts[count] * 100 / prices.length);
            tab.push([count, counts[count],percentage]);
        }

        return tab;
    }

    calculateStatusStats(sportunities) {
        let statuss = [];

        sportunities.forEach(sportunity => {
            let status = 0 ;
            if (sportunity.node.cancel_date) status = "CANCELLED";
            else if (status == 0) status = sportunity.node.creation_status.status;
            statuss.push(status);
        });

        let counts = {};

        for(var i = 0; i< statuss.length; i++) {
            var num = statuss[i];
            counts[num] = counts[num] ? counts[num]+1 : 1;
        }

        let tab = [];

        for (var count in counts) {
            let percentage = Math.round(counts[count] * 100 / statuss.length);
            tab.push([count, counts[count],percentage]);
        }

        return tab;
    }

    render() {
        let sportunities = this.props.viewer.sportunities.edges ;

        let kinds = this.calculateKindStats(sportunities);
        let prices = this.calculatePriceStats(sportunities);
        let cancelleds =this.calculateStatusStats(sportunities);

        return (
            <div className="container" style={{marginTop:20}}>
                <table className="table table-hover table-condensed">
                    <thead>
                        <tr>
                            <th>Privacy</th>
                            <th>Nb of sportunities</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            kinds.map((kind,index) => {
                                return (<tr key={index}><td>{kind[0]}</td><td>{kind[1]}</td><td>{kind[2]}</td></tr>)
                            }
                        )}
                    </tbody>
                </table>
                <table className="table table-hover table-condensed">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Nb of sportunities</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            prices.map((price,index) => {
                                return (<tr key={index}><td>{price[0]}</td><td>{price[1]}</td><td>{price[2]}</td></tr>)
                            }
                        )}
                    </tbody>
                </table>
                <table className="table table-hover table-condensed">
                    <thead>
                        <tr>
                            <th>Cancelled</th>
                            <th>Nb of sportunities</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            cancelleds.map((cancelled,index) => {
                                return (<tr key={index}><td>{cancelled[0]}</td><td>{cancelled[1]}</td><td>{cancelled[2]}</td></tr>)
                            }
                        )}
                    </tbody>
                </table>
            </div>            
        )

    }
}



SportunityDashboard.propTypes = ({
  children: React.PropTypes.node,
});

export default Relay.createContainer(SportunityDashboard, {
  fragments: {
    viewer: () => Relay.QL`
    fragment on Viewer { 
        sportunities (last:1000) {
            edges {
                node {
                    price {
                        cents
                    }
                    kind
                    creation_status {
                        status
                        reason
                    }
                    cancel_date
                }
            }
        }
    }`,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Dashboard/SportunitiesDashboard.js